import { makeStyles } from "tss-react/mui"

export const useStyles = makeStyles()(({ spacing }) => ({
  modalContent: {
    flex: 1,
    minHeight: 0,
    height: "auto",
    padding: 0,
    overflow: "hidden"
  },
  page: {
    flex: 1,
    minHeight: 0,
    overflow: "auto",
    padding: spacing(6, 5)
  }
}))
